export default __webpack_public_path__ + "static/media/grayPinterest.53f022e5.svg";